const stop = (stopSetter: () => void, timeout = 3000) => {
  setTimeout(async () => {
    stopSetter();
  }, timeout);
};

export default { stop };
